import { InfoCircle, Zap } from "@untitledui/icons";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

type NoInsightsEmptyStateProps = {
  backgroundImage: string;
  align?: "left" | "center";
  className?: string;
  onRunSafetyCheck?: () => void;
};

export const NoInsightsEmptyState = ({
  backgroundImage,
  align = "left",
  className,
  onRunSafetyCheck,
}: NoInsightsEmptyStateProps) => {
  return (
    <div
      className={cn("relative w-full overflow-hidden rounded-xl bg-cover bg-center", className)}
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <div
        className={cn("absolute inset-0 flex items-center", align === "center" ? "justify-center" : "justify-start")}
      >
        <div className={cn("max-w-md px-12", align === "center" && "text-left")}>
          <div className="flex items-center gap-2">
            <h4 className="text-lg font-semibold text-white">No safety insights available yet</h4>
          </div>
          <p className="text-sm text-gray-300 mt-2 mb-5 leading-relaxed">
            We don't have safety data for this creator because they haven't yet tagged videos with your product or
            generated enough engagement.
          </p>
          <Button
            variant="secondary"
            size="sm"
            className="w-fit font-semibold bg-white text-primary border border-border-primary"
            onClick={onRunSafetyCheck ?? (() => {})}
          >
            <Zap className="w-4 h-4" />
            Run safety check on this creator
          </Button>
        </div>
      </div>
    </div>
  );
};
